import React from 'react';

function VersionSetting() {
    return (
        <div>Version Setting</div>
    );
}

export default VersionSetting;
